import React from 'react';
import PropTypes from 'prop-types';

import AutoComplete from '../MultiAutoComplete';

const buildOption = (address) => ({ label: address.line1, value: address });

const onInputChange = (addresses = []) => (query = '') => {
  console.log('addresses', addresses);
  const queryLC = query.toLowerCase();
  const result = addresses.filter(a => a.line1.toLowerCase().indexOf(queryLC) >= 0).map(buildOption);
  console.log('res', result);
  return result;
};

class AddressAutoComplete extends React.Component {
  state = {
    options: [],
  };

  componentWillMount() {
    this.setState({
      options: onInputChange(this.props.addresses)(''),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.addresses !== this.props.addresses) {
      this.setState({
        options: onInputChange(this.props.addresses)(''),
      });
    }
  }

  handleKeyPress = (evt) => {
    console.log('handleKeyPress', this.state);
    if (evt.key === 'Enter') {
      this.addCustomer();
    }

    evt.stopPropagation();
  };

  render() {
    const { addresses, value, onAdd, onChange, label, helperText, allowCreate, ...other } = this.props;
    const { options } = this.state;
    console.log('addresses', addresses);
    console.log('options', options);
    return (
      <AutoComplete
        label={label}
        helperText={helperText}
        options={options}
        onInputChange={(query) => {
          console.log('q', query);
          this.setState({
            options: onInputChange(addresses)(query),
          });
        }}
        value={value ? buildOption(value) : null}
        onChange={(value) => {
          console.log('onChange', value);
          if (value.__isNew__) {
            onAdd && onAdd(value.value);
          } else {
            onChange(value.value);
          }
        }}
        onCreateOption={(value) => {
          console.log('onCreateOption', value);
          onAdd && onAdd(value.value);
        }}
        {...other}
        id="address"
        placeholder="Select Address..."
        allowCreate={allowCreate}
      />);
  }
};

AddressAutoComplete.propTypes = {
  addresses: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default AddressAutoComplete;



// WEBPACK FOOTER //
// ./src/components/Common/AddressAutoComplete/index.js